// import { di } from '@intigral/domain';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { container } from '@intigral/domain/lib/DataDomain';
import { IMpxService } from '@intigral/domain/lib/application/services/MpxService';
import { DI } from '@intigral/constant/config/DIContainer';
const useChannelListByCategory = (category: any) => {
    const [channels, setChannels] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const { channels: userChannels, isLoading } = useSelector((state: any) => state.liveTv.userChannels) ?? [];

    useEffect(() => {
        async function getChannelList() {
            setLoading(true);
            if (!isLoading) {
                try {
                    const mpxService = container.resolve<IMpxService>(DI.SERVICES.IMpxService);
                    const response = await mpxService.getChannelListByCategory(category?.filterName || 'Sports');
                    // const response: any = {};
                    const resChannelsIds = response?.entries?.map((channel) => channel.id) || [];
                    const filteredChannels = userChannels?.filter((el) => resChannelsIds.includes(el.channelID)) || [];
                    setChannels(filteredChannels);
                } catch (e) {
                    setChannels([]);
                } finally {
                    setLoading(false);
                }
            }
        }

        getChannelList();
    }, [category, isLoading]);

    return { channels, loading };
};

export default useChannelListByCategory;
